import { render } from "./EstMenu.vue?vue&type=template&id=3860bf03"
import script from "./EstMenu.vue?vue&type=script&lang=js"
export * from "./EstMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__